import { render, staticRenderFns } from "./OwnerOrganizationTable.vue?vue&type=template&id=0c68af70&"
import script from "./OwnerOrganizationTable.vue?vue&type=script&lang=js&"
export * from "./OwnerOrganizationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports